import { render, staticRenderFns } from "./IDetail.vue?vue&type=template&id=cf9520ec&"
import script from "./IDetail.vue?vue&type=script&lang=js&"
export * from "./IDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports